const store = {
    namespaced: true,
    state() {
        return {
            mainBanners: null,
            mainProductSliders: null,
            farmacieProductPageSliders: [],
            productOfTheDay: null
        };
    },
    getters: {
        mainBanners: state => state.mainBanners,
        mainProductSliders: state => state.mainProductSliders,
        farmacieProductPageSliders: state => state.farmacieProductPageSliders,
        getProductOfTheDay: state => state.productOfTheDay
    },
    mutations: {
        SET_MAIN_BANNERS: (state, data) => (state.mainBanners = data),
        SET_MAIN_PRODUCT_SLIDERS: (state, data) => (state.mainProductSliders = data),
        SET_FARMACIE_PRODUCT_PAGE_SLIDERS: (state, data) => (state.farmacieProductPageSliders = data),
        SET_PRODUCT_OF_THE_DAY: (state, data) => (state.productOfTheDay = data)
    },
    actions: {
        fetchMainBanners: async function ({ commit }, data) {
            try {
                const res = await this.$axios({
                    method: 'get',
                    url: `/settings/main_page_settings`
                });

                commit('SET_MAIN_BANNERS', res.data);
            } catch (e) {
                console.error(e);
                // commit('SET_MAIN_BANNERS', );
            }
        },
        fetchMainProductSliders: async function ({ commit, rootGetters }, sliderKey) {
            const isFarmacie = rootGetters['global/getIsFarmacie'];
            let url = `/general/sliders`;
            let result = null;

            if (isFarmacie) {
                url = `/general/sliders?is_product_page=true`;
            }

            if (sliderKey) {
                if (sliderKey === 'productFarmacie') {
                    url = `/general/sliders?is_product_page=true`;
                } else {
                    url = `/general/sliders?key=${sliderKey}`;
                }
            }

            try {
                const res = await this.$axios({
                    method: 'get',
                    url
                });

                if (isFarmacie) {
                    result = res.data.map((slider, index) => {
                        return {
                            title: slider.carouselName,
                            id: slider.slug ? slider.slug : '',
                            products: slider.products,
                            slug: slider.slug ? slider.slug : ''
                        };
                    });
                } else {
                    result = res.data;
                }

                if (sliderKey === 'productFarmacie') {
                    commit('SET_FARMACIE_PRODUCT_PAGE_SLIDERS', result);
                } else {
                    commit('SET_MAIN_PRODUCT_SLIDERS', result);
                }
            } catch (e) {
                console.error(e);
                commit('SET_MAIN_PRODUCT_SLIDERS', { products: [] });
            }
        },
        fetchProductOfTheDay: async function ({ commit }) {
            try {
                const data = await this.$axios.$get('general/v2/product_of_the_day/');
                commit('SET_PRODUCT_OF_THE_DAY', data);
            } catch (e) {
                console.error(e);
            }
        }
    }
};

export default store;
